import React from 'react';

const AuthInfoClockIcon=()=> {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3519_41653)">
        <path
          d="M15.25 15.7891L12 12.5391V6.03906"
          stroke="#08081B"
          strokeWidth="0.96"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.5 12.5078C21.5 14.3867 20.9428 16.2235 19.899 17.7857C18.8551 19.348 17.3714 20.5656 15.6355 21.2847C13.8996 22.0037 11.9895 22.1918 10.1466 21.8253C8.30383 21.4587 6.61109 20.5539 5.28249 19.2253C3.95389 17.8967 3.0491 16.204 2.68254 14.3612C2.31598 12.5184 2.50412 10.6082 3.22315 8.87232C3.94218 7.13642 5.15982 5.65272 6.72209 4.60885C8.28435 3.56498 10.1211 3.00781 12 3.00781H21.5V12.5078Z"
          stroke="#08081B"
          strokeWidth="0.96"
        />
      </g>
      <defs>
        <clipPath id="clip0_3519_41653">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.507812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default AuthInfoClockIcon